import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

interface CarouselRenderOptions {
  arrowClassName?: string;
  paginationClassName?: string;
  paginationItemClassName?: string;
}

export const renderCarouselPagination =
  (options: CarouselRenderOptions = {}) =>
  ({ pages, activePage, onClick }: any) =>
    (
      <div className={options.paginationClassName || "pagination"}>
        {(pages || []).map((page: number) => (
          <button
            key={page}
            type="button"
            onClick={() => onClick(page - 1)}
            className={`${
              options.paginationItemClassName || "pagination-item"
            } ${activePage === page ? "active" : ""}`}
            aria-label={`Página ${page}`}
          />
        ))}
      </div>
    );

export const renderCarouselArrow =
  (options: CarouselRenderOptions = {}) =>
  ({ type, onClick, isEdge }: any) => {
    const isPrevious = type === "PREV";
    const arrowClass = options.arrowClassName || "arrowHome";

    return (
      <div className={`${arrowClass}-slot ${isPrevious ? "prev" : "next"}`}>
        <button
          type="button"
          onClick={onClick}
          disabled={isEdge}
          className={`${arrowClass} ${isPrevious ? "prev" : "next"}`}
          aria-label={isPrevious ? "Anterior" : "Próximo"}
          style={{ visibility: isEdge ? "hidden" : "visible" }}
        >
          {isPrevious ? (
            <FaChevronLeft color="#2D5BFF" size={16} />
          ) : (
            <FaChevronRight color="#2D5BFF" size={16} />
          )}
        </button>
      </div>
    );
  };
